import { masteredSellPrice, doubleXp } from './farmRules.mjs';

// The order the farm's pop-ups show in: the server's events (welcome_back, level_up, mastery)
// as they came, plus friends' canisters (fuel_gifts, from farm.new_gifts).
const SHOWN = new Set(['welcome_back', 'level_up', 'mastery', 'fuel_gifts', 'helpers']);
export function createPopupQueue() {
  const items = [];
  return {
    push(events) { for (const e of events ?? []) if (SHOWN.has(e?.type)) items.push(e); },
    next() { return items.shift() ?? null; },
    get size() { return items.length; },
  };
}

// The words on the level-up pop-up: what the coins are, and a named list of what the level
// unlocked (a picture alone didn't say "this is new in the market").
// The heading speaks to the player in their character's grammatical gender (Natalka / Ken).
export function levelUpLabels(event, crops = {}, character = 'natalka', tools = {}) {
  const items = [
    ...(event?.unlocks?.crops ?? []).map((id) => ({ kind: 'crop', id, name: crops[id]?.name_pl ?? id })),
    ...(event?.unlocks?.tools ?? []).map((t) => ({ kind: 'tool', id: t.tool, size: t.size, name: `${tools[t.tool]?.name_pl ?? t.tool} ${t.size}×${t.size}` })),
    ...(event?.unlocks?.expansion ? [{ kind: 'expansion', size: event.unlocks.expansion, name: `Pole ${event.unlocks.expansion}×${event.unlocks.expansion}` }] : []),
  ];
  return { gift: 'Prezent za poziom', heading: items.length ? (character === 'ken' ? 'Odblokowałeś:' : 'Odblokowałaś:') : null, items };
}

// The words on the mastery pop-up (owner, 2026-09-29): stars alone didn't tell a child that the
// crop now earns more, and "Tablica Mistrza" meant nothing — it is a golden plaque to put up.
export function masteryLabels(e, farmCatalog) {
  const crop = farmCatalog?.crops?.[e.crop];
  const name = crop?.name_pl ?? e.crop;
  const now = masteredSellPrice(crop, e.stars, farmCatalog);
  const before = masteredSellPrice(crop, e.stars - 1, farmCatalog);
  return {
    price: `${name} sprzedaje się teraz za ${now} {coin} (było ${before} {coin})`,
    reward: `Nagroda: +${e.xp} XP  +${e.coins} {coin}`,
    plaque: e.sign ? `{medal} Złota tabliczka: ${name} czeka w {crate} Schowku!` : null,
  };
}

// The welcome-back hour (owner 2026-10-16): minutes of double XP left, null when it's over.
export function doubleXpMinutes(farm, nowMs) {
  return doubleXp(farm, nowMs) ? Math.max(1, Math.ceil((Date.parse(farm.rested_until_iso) - nowMs) / 60000)) : null;
}

// The banner's line: "for an hour" when it has just begun, else how many minutes are left.
export function welcomeBackLine(farm, nowMs) {
  const min = doubleXpMinutes(farm, nowMs);
  if (min == null) return null;
  return min >= 59 ? 'Podwójne XP przez godzinę {xp_star}' : `Podwójne XP jeszcze przez ${min} min {xp_star}`;
}
